import { SVGProps } from 'react';

export const IconDownload = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 24 24'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.1113 20.1727C7.1113 19.7158 7.48169 19.3454 7.9386 19.3454H16.2116C16.6685 19.3454 17.0389 19.7158 17.0389 20.1727C17.0389 20.6296 16.6685 21 16.2116 21H7.9386C7.48169 21 7.1113 20.6296 7.1113 20.1727Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0582 3C12.5497 3 12.9481 3.3704 12.9481 3.8273V13.6583L15.9808 10.8389C16.3284 10.5159 16.8918 10.5159 17.2394 10.8389C17.5869 11.162 17.5869 11.6858 17.2394 12.0089L12.6875 16.2406C12.34 16.5637 11.7765 16.5637 11.429 16.2406L6.76065 11.9006C6.41312 11.5775 6.41312 11.0537 6.76065 10.7306C7.10817 10.4075 7.67163 10.4075 8.01916 10.7306L11.1683 13.6583V3.8273C11.1683 3.3704 11.5668 3 12.0582 3Z'
        fill='currentColor'
      />
    </svg>
  );
};
